import { Flex, Heading, Box, Text, FlexProps } from '@chakra-ui/react';
import { colors } from 'theme/colors';
import React, { memo } from 'react';

interface ItemProps {
  heading: String;
  text: String;
}
interface IProps extends FlexProps {
  items: ItemProps[];
}

const MessageInfoComponent: React.FC<IProps> = ({ items, ...props }) => {
  return (
    <Flex
      p="16px"
      borderRadius="4px"
      border="1px solid"
      borderColor="brand.gray600"
      boxShadow="0px 5px 15px rgba(0, 0, 0, 0.1)"
      {...props}
      flexDirection="column"
    >
      {items.map((value, index) => {
        return (
          <Box key={index}>
            <Heading color="brand.tertiary" as="h4" fontSize="14px" display="inline">
              {value.heading}
            </Heading>
            <Text fontSize="14px" color={colors.brand[900]} display="inline">
              {value.text}
            </Text>
          </Box>
        );
      })}
    </Flex>
  );
};

export const MessageInfo = memo(MessageInfoComponent);
